import { render, staticRenderFns } from "./UnitTransferList.vue?vue&type=template&id=925e2a1e&"
import script from "./UnitTransferList.vue?vue&type=script&lang=js&"
export * from "./UnitTransferList.vue?vue&type=script&lang=js&"
import style0 from "./UnitTransferList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports